/* eslint-disable react/no-multi-comp */
import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Loadable from 'react-loadable';
import Error from 'Favourites/scenes/Error';
import Page from 'Favourites/components/Page';
import LoadableError from 'components/LoadableError';
import ShoppingList from 'Favourites/scenes/ShoppingList';
import { getShowPhraseAppKeyToggle } from 'helpers/i18n';

const showPhraseAppKeyToggle = getShowPhraseAppKeyToggle();

// eslint-disable-next-line react/prop-types
const loadableErrorHandler = ({ error }) => error ? <LoadableError /> : null;

const loadable = (loader, loading = loadableErrorHandler) =>
    Loadable({
        loader,
        delay: false,
        loading,
    });

const PhraseAppKeyToggle = loadable(() => import('components/PhraseAppKeyToggle'), () => null);


class Routes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            key: 0,
        };
    }

    renderPhraseAppKeyToggle = () => showPhraseAppKeyToggle && <PhraseAppKeyToggle onToggle={() => this.reRenderApplication()}/>

    render() {
        return (
            <React.Fragment key={this.state.key}>
                <Switch>
                    <Route path="/:country/:language/shoppinglist/" render={(routeProps)=>  <Page {...routeProps} route={{ container: ShoppingList, listType: 'onlineshoppinglist', trackingName: 'ShoppingList' }} />} />
                    <Route path="/:country/:language/*" render={(routeProps) => <Page {...routeProps} route={{ container: Error }}/>} exact={false} />
                </Switch>
                {this.renderPhraseAppKeyToggle()}
            </React.Fragment>
        );
    }

    reRenderApplication() {
        this.setState({
            key: this.state.key + 1,
        });
    }
}

export default Routes;
